import { useState, useCallback } from 'react';

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = useState({
    isVisible: false,
    position: { x: 0, y: 0 },
    menuItems: [],
    contextType: 'canvas'
  });

  const showContextMenu = useCallback((event, menuItems, contextType = 'canvas') => {
    event.preventDefault();
    event.stopPropagation();

    // Calculate position to ensure menu stays within viewport
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const menuWidth = 200; // Approximate menu width
    const menuHeight = Math.min(400, menuItems.length * 40); // Approximate menu height

    let x = event.clientX;
    let y = event.clientY;

    // Adjust position if menu would go off-screen
    if (x + menuWidth > viewportWidth) {
      x = viewportWidth - menuWidth - 10;
    }
    if (y + menuHeight > viewportHeight) {
      y = viewportHeight - menuHeight - 10;
    }

    setContextMenu({
      isVisible: true,
      position: { x, y },
      menuItems,
      contextType
    });
  }, []);

  const hideContextMenu = useCallback(() => {
    setContextMenu(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);

  return {
    contextMenu,
    showContextMenu,
    hideContextMenu
  };
};
